// this is an autogenerated file from DesignSystem/PreviewDocumentModal/Content/Content/HtmlFile/Content/Content/Content/Footer/SendForSignatureAction/Content/Content/CancelAction/Content/SubmitAction/mutation.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__DesignSystem_PreviewDocumentModal_Content_Content_HtmlFile_Content_Content_Content_Footer_SendForSignatureAction_Content_Content_CancelAction_Content_SubmitAction($id: uuid!) {
  update_documents_signature_requests_by_pk(
    pk_columns: { id: $id }
    _set: { status: cancelled }
  ) {
    id
    status
  }
}

`